const Config = {
    // BASE_URL: "http://localhost:9000/",
    // BASE_URL: "https://98da-39-53-116-92.ngrok.io/",
    BASE_URL: "https://young-glade-24121.botics.co/",
}

export default Config;